import axios from 'axios'
import router from '../router'
import { ElMessage, ElMessageBox } from 'element-plus'
import store from '../store'
import { localGet, localDel, localSet } from '@/config/storage'

var showMessageBoxEd = false  //是否显示在别的地方登录的弹窗

//axios实例
const ystHttpRequest = axios.create({
	baseURL: process.env.NODE_ENV === 'development' ? '/AdminApi/zjwl' : '/zjwl',
	timeout: 8000 //默认超时时间
})

// 添加请求拦截器
ystHttpRequest.interceptors.request.use(
	config => config,
	err => Promise.reject(err)
)

const toLogin = (message:any, noTips?:any) => {
	store.commit("publicOptions/SAVE_TOKEN", '') //删除vuex中的token
	localDel('token') //删除本地存储中的token
	showMessageBoxEd = false
	if(router.currentRoute.value.meta.module && router.currentRoute.value.meta.module != 'login'){
		if(!localGet('logintips') && !noTips){
			ElMessage.error(message)
			localSet("logintips", new Date().getTime())
		}
		router.replace('/login') //跳转回登录页
		setTimeout(() => {
			localDel('logintips')
		}, 1000)
	}
}

// 添加响应拦截器
ystHttpRequest.interceptors.response.use(
	response => response,
	err => {
		if (err && err.response) {
			switch (err.response.status) {
				case 400:
					ElMessage.error('Error request.')
					break
				// case 401:
				// 	ElMessage.error('Unauthorized, please log in again.')
				// 	break
				case 403:
					ElMessage.error('Access denied.')
					break
				case 404:
					ElMessage.error('Request error, the resource was not found.')
					break
				case 405:
					ElMessage.error('Request method not allowed.')
					break
				case 408:
					ElMessage.error('Request timeout.')
					break
				case 500:
					ElMessage.error('Server side error.')
					break
				case 501:
					ElMessage.error('Network not implemented.')
					break
				case 502:
					ElMessage.error('Network error.')
					break
				case 503:
					ElMessage.error('Service Unavailable.')
					break
				case 504:
					ElMessage.error('Network Timeout.')
					break
				case 505:
					ElMessage.error('The HTTP version does not support the request.')
					break
				default:
					ElMessage.error(`Connection error${err.response.status}.`)
			}
		} else if (err && err.__CANCEL__) {
			ElMessage.error('Request cancelled.')
		} else {
			ElMessage.error('Failed to connect to the server.')
		}
		return Promise.reject(err.response)
	}
)
interface funResult {
	code?: number;
	data?: any;
	message?: any;
}
// axios请求封装
export const secondaryPackagingRequest = ({
  url, //接口路径
  data = {}, //POST参数
  params = {}, //GET参数
  headers = {  //请求头
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  method = 'GET', //请求类型
  timeout = 8000, //超时时间
  isLoading = false, //是否显示加载动画
  needToken = true, //是否需要token
  loadingText, //加载动画文字
  cancelToken, //取消请求
  responseType = 'json', //响应参数类型
  needYstms = true, //响应参数类型
  needTips = true, //请求失败是否提升
  onUploadProgress //上传进度函数
}:any):Promise<funResult> => {
  return new Promise((resolve, reject) => {
	if (needToken) headers.Authorization = 'Bearer ' + localGet('token')
    ystHttpRequest({
      url,
      data,
      params,
      headers,
      method,
      timeout,
      cancelToken,
      responseType,
      onUploadProgress
    }).then(res => {
      let { code, message, msg } = res.data
      if(!message && msg) message = msg
      if (code !== 200 && code!== -10001 && code!== 405 && code!== 401 && code && needTips) ElMessage.error({
      		dangerouslyUseHTMLString: true,
      		message: message,
      }) //请求错误时的提示,-20000为特定错误，需要根据具体情况特殊处理
      if (code === 401) { // 登录超时 删除token 返回登录页
        toLogin(message)
      }else if(code == 405){
      		if(!showMessageBoxEd){
      			showMessageBoxEd = true
      			ElMessageBox.confirm(message, '系统提示', {
      			  confirmButtonText: '确认',
      			  cancelButtonText: '取消',
      			  type: 'warning'
      			}).then(async () => {
      				toLogin(message, 1)
      			}).catch(() => {
      				toLogin(message, 1)
      			})
      		}
      }
      if (responseType === 'arraybuffer') resolve(res)
      else resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}